/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SummaryMode } from './summaryMode';

export type SummarizeProfileEndpointParams = {
mode: SummaryMode;
};
